<template>
  <div id="password">
    <div class="d-flex justify-content-between align-self-center my-4">
      <span class="title">
        密碼
      </span>
    </div>
    <AGCEditGroupPassword v-model="inputVal"
                          label="密碼"
                          type="password"
                          disabled
                          enableEdit
    >
    </AGCEditGroupPassword>
  </div>
</template>

<script>
import AGCEditGroupPassword from '../form/AGCEditGroupPassword.vue';

import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

export default {
  mixins: [formMixin, vModelMixin],
  components: {
    AGCEditGroupPassword,
  },
  mounted() {

  },
};
</script>
